/* eslint-disable react/jsx-wrap-multilines */
import React, { Component, Fragment } from 'react';
import Tree from '../../Tree';
import { countTitle, isSafari } from '../utils';
import { getSysFieldid } from '@platform/api';
import SvgIcon from '../../SvgIcon';

const TreeNode = Tree.TreeNode;

export default class ReferTree extends Component {
    static defaultProps = {
        defaultExpandAll: false,
        checkStrictly: true,
        autoExpandParent: false,
        id: 'refpk',
        pid: 'pid',
    };

    constructor(props) {
        super(props);
        this.state = { expandedKeys: {}, isSafari: isSafari() };
    }

    componentWillMount() {
        this.propsToState(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.propsToState(nextProps);
    }

    propsToState = (props) => {
        let expandedKeys = {};
        props.expandedKeys.forEach((e) => {
            expandedKeys[e] = true;
        });
        this.setState({ expandedKeys });
    };

    makeDOM = (data) => {
        let {
                id,
                treeSearchKey,
                hideTreeIcon = false,
                fieldidKey,
            } = this.props,
            { expandedKeys, isSafari } = this.state;
        if (Array.isArray(data)) {
            return data.map((e) => {
                let title = countTitle(e._display || e.refname, treeSearchKey);
                // if(e.refcode==='AIM') e.disabled = true;
                return (
                    <TreeNode
                        key={e[id]}
                        title={
                            <span className="refer-treenode-title">
                                {/* {e.isleaf === false ? (
	                                <span
	                                    className={`refer-tree-switch iconfont ${
	                                        expandedKeys[e.refpk]
	                                            ? 'icon-wenjianjiadakai'
	                                            : 'icon-wenjianjia'
	                                    }`}
	                                />
	                            ) : (
	                                <span className="refer-tree-point" />
	                            )} */}
                                <span
                                    className="refer-tree-title"
                                    fieldid={getSysFieldid('tree-title')}
                                >
                                    {title}
                                </span>
                            </span>
                        }
                        icon={
                            hideTreeIcon ? (
                                <Fragment></Fragment>
                            ) : e.isleaf === false ? (
                                // <span
                                //     className={`refer-tree-switch iconfont tree-wenjian ${
                                //         expandedKeys[e.refpk]
                                //             ? 'icon-wenjianjiadakai'
                                //             : 'icon-wenjianjia'
                                //     }`}
                                // />
                                expandedKeys[e.refpk] ? (
                                    <SvgIcon type="kaiqi" />
                                ) : (
                                    <SvgIcon type="guanbi" />
                                )
                            ) : (
                                <span className="refer-tree-point" />
                            )
                        }
                        liAttr={{
                            fieldid: getSysFieldid(
                                `${
                                    fieldidKey
                                        ? e[fieldidKey]
                                        : e.refcode || e.refname
                                }_node`
                            ),
                        }}
                        treeNodeData={e}
                        disableCheckbox={e.disabled}
                        isLeaf={e.isleaf !== false}
                        switcherClass={`refer-tree-node-switcher ${
                            isSafari ? 'safari-node-switcher' : ''
                        }`}
                        titleClass="refer-tree-node-title"
                        // disabled={e.disabled || false}
                    >
                        {this.makeDOM(e.children)}
                    </TreeNode>
                );
            });
        } else {
            return data;
        }
    };

    render() {
        const {
            treeDataWithChildren,
            checkedKeys,
            selectedKeys,
            keyMap,
            id,
            data,
            pid,
            root,
            checkable,
            lazyLoad,
            // onFocus,
            ...otherProps
        } = this.props;
        return (
            <Tree
                showLine
                focusable
                checkedKeys={checkedKeys}
                selectedKeys={(Array.isArray(selectedKeys)
                    ? selectedKeys
                    : []
                ).filter((e) => keyMap[e])}
                {...otherProps}
                checkable={checkable}
                treeData={treeDataWithChildren}
                lazyLoad={lazyLoad}
                renderTreeNodes={(data) => {
                    return this.makeDOM(data);
                }}
                mustExpandable={true}
            >
                {/* {this.makeDOM(treeDataWithChildren)} */}
            </Tree>
        );
    }
}
